import { useCallback } from "react"

import { useReducedMotion } from "framer-motion"

import { ERoute } from "@/3514/constants"
import {
    type IParticipantHeaderState as IState,
    useParticipantHeaderSelector as useSelector
} from "@/3514/entities/participant.header"
import { type TScreenBreakpoints, useScreenBreakpoints } from "@/3514/hooks"
import type { TEmptyCallback } from "@/shared/types/functions"

import { participantHeaderUiConfig as uiConfig } from "../ui"

function useModulesExcerptsScrollEffects(): {
    scrollIntoModule(imperativeIndex?: number, async?: boolean): void
} {
    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    const { excerpts: modules }: IState = useSelector()

    const isReducedMotion: boolean = useReducedMotion()

    const scrollIntoModule: (imperativeIndex?: number, async?: boolean) => void = useCallback(
        (imperativeIndex?: number, async = false): void => {
            const _handler: TEmptyCallback = (): void => {
                if (breakpoints.xs && (modules.length ? modules.length <= 2 : false)) return void 0
                if (!breakpoints.xs && (modules.length ? modules.length < 3 : false)) return void 0

                const _index: number = imperativeIndex
                    ? imperativeIndex - 1
                    : Number(window.location.pathname.split(`${ERoute.Participant_Dashboard}/`)[1]) - 1

                if (uiConfig.excerptsListRef.current) {
                    setTimeout(
                        (): void =>
                            uiConfig.excerptsListRef.current?.children?.[_index]?.scrollIntoView({
                                behavior: isReducedMotion ? "instant" : "smooth",
                                block: uiConfig.excerptsListRef.current.children.length === _index ? "end" : "center",
                                inline: uiConfig.excerptsListRef.current.children.length === _index ? "end" : "center"
                            }),
                        100
                    )
                }

                return void 0
            }

            if (async) {
                setTimeout((): void => _handler(), 50)
            } else {
                _handler()
            }
        },
        [breakpoints.xs, modules.length, isReducedMotion]
    )

    return { scrollIntoModule }
}

export { useModulesExcerptsScrollEffects }
